
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34728',
  depVersions: {
  "documents-public-ui": "static-1.34728",
  "atom": "static-1.5164",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2587",
  "client-types": "static-1.479",
  "cssUtils": "static-1.817",
  "customer-data-filters-ui": "static-1.40096",
  "customer-data-objects": "static-1.7767",
  "customer-data-property-utils": "static-1.8185",
  "documents-lib": "static-1.34733",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.343",
  "FormsCommonComponents": "static-1.86102",
  "FormUrlGenerator": "static-2.4811",
  "foundations-theming-specialty": "static-1.2238",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.105",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5681",
  "hs-test-utils": "static-1.8107",
  "hub-http": "static-1.6311",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11871",
  "HubStyleTokens": "static-2.11564",
  "I18n": "static-7.1634",
  "icons": "static-2.651",
  "jasmine-immutable": "static-1.3111",
  "jasmine-runner": "static-1.6550",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7245",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5485",
  "quartz": "static-1.7139",
  "react": "static-7.187",
  "react-dlb": "static-1.80",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16771",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5410",
  "react-virtualized": "static-2.100",
  "reference-resolvers": "static-1.8264",
  "reference-resolvers-lite": "static-1.8188",
  "reporting-data": "static-1.67903",
  "reporting-reports": "static-1.67581",
  "reporting-snowflake": "static-1.56521",
  "reporting-testing-lib": "static-1.9836",
  "reporting-visualizations": "static-1.59979",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.9034",
  "sanitize": "static-1.4566",
  "sanitize-text": "static-1.8234",
  "self-service-api": "static-1.10337",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1835",
  "signup-constants": "static-1.19046",
  "signup-ui-url-generator": "static-2.8145",
  "StyleGuideUI": "static-3.488",
  "superstore": "static-1.4850",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4852",
  "ui-addon-form-validation": "static-1.11079",
  "ui-asset-management-lib": "static-1.11149",
  "ui-images": "static-2.1174",
  "UIComponents": "static-3.8510",
  "usage-tracker": "static-1.7438",
  "usage-tracker-container": "static-1.7428",
  "usage-tracker-core": "static-1.7288",
  "viral-links-lib": "static-1.7158",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9751",
  "foundations-components": "static-1.8104",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.917",
  "quartz-core": "static-1.6358",
  "quick-fetch": "static-1.3984",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4745",
  "ui-addon-i18n": "static-1.11241",
  "ui-addon-upgrades": "static-9.18116",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3467",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3416",
  "quartz-webpack": "static-1.3363",
  "foundations-assets": "static-1.4958",
  "foundations-theming": "static-1.4522",
  "hub-http-shared-msw-handlers": "static-1.10179",
  "hubspotter-http": "static-1.4718",
  "sassPrefix": "static-1.157",
  "conversations-skeleton-state": "static-1.7339",
  "crm-message-bus": "static-1.43212",
  "customer-data-filters-ui-msw-helpers": "static-1.22531",
  "customer-data-objects-ui-components": "static-1.13121",
  "customer-data-reference-ui-components": "static-1.13259",
  "customer-data-ui-utilities": "static-1.9915",
  "events-data-lib": "static-1.320",
  "framework-builder-read-service-client": "static-1.4072",
  "framework-data-schema-quick-fetch": "static-1.6884",
  "framework-data-schema-resolvers": "static-1.6979",
  "inbound-db-meta-service-client": "static-1.3653",
  "inbound-db-properties-service-client": "static-1.3912",
  "multi-account-reference-resolvers": "static-1.1071",
  "onboarding-tours": "static-1.16764",
  "reporting-datasets-permissions-lib": "static-1.13931",
  "ui-addon-teams": "static-1.21668",
  "quartz-auth": "static-1.814",
  "ui-business-units-lib": "static-1.9150",
  "usage-tracker-session-replay": "static-1.5124",
  "ai-components-ui-library": "static-1.9177",
  "ContentUtils": "static-1.68610",
  "customer-data-properties": "static-1.51889",
  "forms-ai-lib": "static-1.4456",
  "forms-utils-lib": "static-1.12745",
  "foundations-components-test-utils": "static-1.5587",
  "react-dnd-compat": "static-1.4703",
  "react-tinymce": "static-1.55477",
  "tinymce-config": "static-2.54603",
  "ui-gdpr-components": "static-1.10440",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3507",
  "HeadJS": "static-2.766",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3218",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.148",
  "ui-fonts": "static-1.826",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4415",
  "csstype": "static-1.50",
  "quartz-head": "static-1.804",
  "web-vitals": "static-1.7",
  "batch-promise": "static-1.1632",
  "external-options-client-types": "static-1.4199",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.814",
  "frontend-preferences-client": "static-1.8016",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "persist-promise": "static-1.3789",
  "reporting-client-types": "static-1.2559",
  "apollo-stack-hubspot": "static-3.87",
  "growth-payments-core": "static-1.25639",
  "hubspot-apollo-client": "static-1.4967",
  "foundations-components-legacy": "static-1.1129",
  "merchandise-lib": "static-1.265",
  "quartz-routing": "static-1.569",
  "hs-story-utils": "static-1.9512",
  "react-flip-move": "static-1.72",
  "nested-table": "static-1.315",
  "timezone-utils": "static-2.5333",
  "seat-types-lib": "static-1.221",
  "react-create-root-preference": "static-1.32",
  "bend-plugin-foundations-components": "static-1.4374",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2159",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.841",
  "mobile-manifest-mixins": "static-1.540",
  "module-federation": "static-1.24",
  "quartz-test": "static-1.814",
  "quartz-tracking": "static-1.518",
  "trellis-components": "static-1.2178",
  "bend-plugin-chirp-manifest": "static-1.155",
  "chirp-fetch": "static-1.1977",
  "purchase-motions-components": "static-1.6054",
  "salesImages": "static-1.526",
  "ts-schema": "static-1.4147",
  "bender-build-tools": "static-1.3278",
  "bend-plugin-foundations-theming": "static-1.3005",
  "stylex": "static-1.34",
  "restore-request-side-panel-lib": "static-1.1098",
  "react-immutable-render-mixin": "static-1.9",
  "hs-resources": "static-1.264",
  "pulse": "static-1.686",
  "conditional-properties-service-client": "static-1.3864",
  "crm-pipelines-api-client-types": "static-1.4205",
  "fdsr-migration-layer": "static-1.98",
  "multi-currency-client-types": "static-1.3758",
  "getting-started-shared-tasks": "static-1.18659",
  "growth-data-modal": "static-1.5568",
  "growth-onboarding-confetti": "static-1.3156",
  "growth-onboarding-next-action-utils": "static-1.2180",
  "navigation-components": "static-1.18240",
  "onboarding-tours-client": "static-1.4978",
  "onboarding-tours-utils": "static-1.830",
  "ui-shepherd-react": "static-3.10312",
  "ui-shepherd-tracker": "static-1.7693",
  "ui-universal-auth": "static-1.9082",
  "user-context": "static-1.5199",
  "hubspotter-http-shared-msw-handlers": "static-1.10177",
  "magpie-lib": "static-1.5610",
  "navigation-messaging": "static-1.7567",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21721",
  "copilot-toolkit": "static-1.11360",
  "cms-field-types": "static-1.4902",
  "content-icons-ui": "static-1.2251",
  "integrations-lib": "static-1.16445",
  "calling-global-api": "static-1.64820",
  "calling-internal-common": "static-1.31398",
  "calling-lifecycle-internal": "static-1.66202",
  "calling-lifecycle-messages": "static-1.58496",
  "commerce-products-lib": "static-1.9868",
  "crm-links": "static-1.6396",
  "customer-data-properties-shared-msw-handlers": "static-1.9506",
  "file-manager-components": "static-1.23844",
  "google-libphonenumber": "static-1.39",
  "inbounddb-objects-service-types": "static-1.4288",
  "meetings-icalendar-utils-lib": "static-1.723",
  "object-builder-ui-client": "static-1.49053",
  "pipeline-validation-client-types": "static-1.4033",
  "property-value-citations": "static-1.2503",
  "smart-property-lib": "static-1.7628",
  "tiered-pricing": "static-1.1413",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9152",
  "final-form": "static-1.71",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19977",
  "tinymce-themes": "static-1.56573",
  "data-token-picker": "static-1.16558",
  "hub-http-contrib": "static-1.3131",
  "interframe": "static-3.4849",
  "tinymce-data": "static-1.40688",
  "tinymce-plugins": "static-1.57717",
  "ui-addon-sales-email": "static-1.5300",
  "onboarding-scopes": "static-1.6551",
  "ui-addon-opt": "static-4.8450",
  "apollo-link-hub-http": "static-2.4742",
  "hubspot-apollo-cache": "static-1.426",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.262",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1029",
  "tanstack-virtual": "static-1.31",
  "purchase-motions-api": "static-1.6057",
  "event-emitter": "static-1.1038",
  "bend-plugin-pulse": "static-1.189",
  "fast-json-patch": "static-1.64",
  "onboarding-data-sync-lib": "static-1.2112",
  "growth-onboarding-next-action-components": "static-1.2208",
  "user-context-client": "static-1.4678",
  "idb-keyval": "static-1.45",
  "magpie-types": "static-1.5070",
  "nest": "static-1.321",
  "reactive-lib": "static-1.815",
  "simple-logging-lib": "static-1.3140",
  "unified-auth-core-lib": "static-1.878",
  "getting-started-shared-tasks-store": "static-1.17777",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1008",
  "integrations-error-boundary-lib": "static-1.13860",
  "integrations-tracking-lib": "static-1.5696",
  "native-integrations-shared-strings": "static-1.7871",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10453",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.596",
  "calling-error-reporting": "static-1.31405",
  "shared-worker-versioning": "static-1.11125",
  "calling-usage-tracker": "static-1.6632",
  "voice-sms-access-library": "static-1.1335",
  "customer-data-tracking": "static-1.6979",
  "commerce-permissions": "static-1.866",
  "products-iframe-lib": "static-1.8168",
  "products-ui-components-shared-msw-handlers": "static-1.10561",
  "location-customization-utils-lib": "static-1.9519",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4244",
  "video-components-external": "static-1.11566",
  "video-data-lib": "static-1.35224",
  "data-agent-kit": "static-1.334",
  "feedback-loader": "static-1.29457",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10262",
  "fsm": "static-1.3819",
  "policy-lib": "static-1.6869",
  "react-colorpicker": "static-2.10297",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10325",
  "FileManagerLib": "static-1.39484",
  "NamespacedHubStyle": "static-2.9125",
  "FileManagerCore": "static-1.39343",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7891",
  "layout-dnd-components": "static-1.12609",
  "layout-dnd-utils": "static-1.11584",
  "react-codemirror": "static-1.10717",
  "ui-addon-emoji-picker": "static-1.9977",
  "ui-brand-identity-lib": "static-1.15590",
  "InboxConnectUtils": "static-4.15044",
  "meetings-connect-utils-lib": "static-1.7694",
  "breeze-engine-core": "static-1.286",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3107",
  "ads-unified-auth-lib": "static-1.256",
  "google-sheets-integration-lib": "static-1.500",
  "microsoft-drive-integration-lib": "static-1.638",
  "slack-ui-library": "static-1.10482",
  "calling-orchestration-schema": "static-1.36112",
  "sales-views-client-types": "static-1.4348",
  "crm-record-cards-service-types": "static-1.3657",
  "content-media-composition-data-lib": "static-1.12601",
  "content-media-compositions": "static-2.16608",
  "media-bridge-lib": "static-1.19075",
  "trellis-story-utils": "static-1.4602",
  "storybook-react": "static-1.34",
  "audio-components": "static-1.6049",
  "FileManagerImages": "static-1.36995",
  "video-components": "static-1.13568",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "urlinator": "static-1.4626",
  "video-embed": "static-1.36058",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8793",
  "ui-coaching-tips": "static-1.28809",
  "ContentData": "static-1.68685",
  "layout-data-lib": "static-1.9909",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22298",
  "outpost": "static-1.4260",
  "growth-onboarding-feedback-components": "static-1.6669",
  "advanced-menus-core": "static-1.15269",
  "advanced-menus-lib": "static-1.12186",
  "ExportDialog": "static-6.10472",
  "ui-memberships-settings-lib": "static-1.34284",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15268",
  "simple-menus-lib": "static-1.16785"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34728",
  "atom": "/atom/static-1.5164",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2587",
  "client-types": "/client-types/static-1.479",
  "cssUtils": "/cssUtils/static-1.817",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40096",
  "customer-data-objects": "/customer-data-objects/static-1.7767",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8185",
  "documents-lib": "/documents-lib/static-1.34733",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.343",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86102",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4811",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2238",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.105",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5681",
  "hs-test-utils": "/hs-test-utils/static-1.8107",
  "hub-http": "/hub-http/static-1.6311",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11871",
  "HubStyleTokens": "/HubStyleTokens/static-2.11564",
  "I18n": "/I18n/static-7.1634",
  "icons": "/icons/static-2.651",
  "jasmine-immutable": "/jasmine-immutable/static-1.3111",
  "jasmine-runner": "/jasmine-runner/static-1.6550",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7245",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5485",
  "quartz": "/quartz/static-1.7139",
  "react": "/react/static-7.187",
  "react-dlb": "/react-dlb/static-1.80",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16771",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5410",
  "react-virtualized": "/react-virtualized/static-2.100",
  "reference-resolvers": "/reference-resolvers/static-1.8264",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8188",
  "reporting-data": "/reporting-data/static-1.67903",
  "reporting-reports": "/reporting-reports/static-1.67581",
  "reporting-snowflake": "/reporting-snowflake/static-1.56521",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9836",
  "reporting-visualizations": "/reporting-visualizations/static-1.59979",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.9034",
  "sanitize": "/sanitize/static-1.4566",
  "sanitize-text": "/sanitize-text/static-1.8234",
  "self-service-api": "/self-service-api/static-1.10337",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1835",
  "signup-constants": "/signup-constants/static-1.19046",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8145",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "superstore": "/superstore/static-1.4850",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4852",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11079",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11149",
  "ui-images": "/ui-images/static-2.1174",
  "UIComponents": "/UIComponents/static-3.8510",
  "usage-tracker": "/usage-tracker/static-1.7438",
  "usage-tracker-container": "/usage-tracker-container/static-1.7428",
  "usage-tracker-core": "/usage-tracker-core/static-1.7288",
  "viral-links-lib": "/viral-links-lib/static-1.7158",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9751",
  "foundations-components": "/foundations-components/static-1.8104",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.917",
  "quartz-core": "/quartz-core/static-1.6358",
  "quick-fetch": "/quick-fetch/static-1.3984",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4745",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11241",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18116",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3467",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3416",
  "quartz-webpack": "/quartz-webpack/static-1.3363",
  "foundations-assets": "/foundations-assets/static-1.4958",
  "foundations-theming": "/foundations-theming/static-1.4522",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10179",
  "hubspotter-http": "/hubspotter-http/static-1.4718",
  "sassPrefix": "/sassPrefix/static-1.157",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7339",
  "crm-message-bus": "/crm-message-bus/static-1.43212",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22531",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13121",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13259",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9915",
  "events-data-lib": "/events-data-lib/static-1.320",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4072",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6884",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6979",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3653",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3912",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1071",
  "onboarding-tours": "/onboarding-tours/static-1.16764",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13931",
  "ui-addon-teams": "/ui-addon-teams/static-1.21668",
  "quartz-auth": "/quartz-auth/static-1.814",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9150",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5124",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9177",
  "ContentUtils": "/ContentUtils/static-1.68610",
  "customer-data-properties": "/customer-data-properties/static-1.51889",
  "forms-ai-lib": "/forms-ai-lib/static-1.4456",
  "forms-utils-lib": "/forms-utils-lib/static-1.12745",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5587",
  "react-dnd-compat": "/react-dnd-compat/static-1.4703",
  "react-tinymce": "/react-tinymce/static-1.55477",
  "tinymce-config": "/tinymce-config/static-2.54603",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10440",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3507",
  "HeadJS": "/HeadJS/static-2.766",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3218",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.148",
  "ui-fonts": "/ui-fonts/static-1.826",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4415",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.804",
  "web-vitals": "/web-vitals/static-1.7",
  "batch-promise": "/batch-promise/static-1.1632",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.814",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8016",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3789",
  "reporting-client-types": "/reporting-client-types/static-1.2559",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "growth-payments-core": "/growth-payments-core/static-1.25639",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4967",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1129",
  "merchandise-lib": "/merchandise-lib/static-1.265",
  "quartz-routing": "/quartz-routing/static-1.569",
  "hs-story-utils": "/hs-story-utils/static-1.9512",
  "react-flip-move": "/react-flip-move/static-1.72",
  "nested-table": "/nested-table/static-1.315",
  "timezone-utils": "/timezone-utils/static-2.5333",
  "seat-types-lib": "/seat-types-lib/static-1.221",
  "react-create-root-preference": "/react-create-root-preference/static-1.32",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4374",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2159",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.841",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.540",
  "module-federation": "/module-federation/static-1.24",
  "quartz-test": "/quartz-test/static-1.814",
  "quartz-tracking": "/quartz-tracking/static-1.518",
  "trellis-components": "/trellis-components/static-1.2178",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.155",
  "chirp-fetch": "/chirp-fetch/static-1.1977",
  "purchase-motions-components": "/purchase-motions-components/static-1.6054",
  "salesImages": "/salesImages/static-1.526",
  "ts-schema": "/ts-schema/static-1.4147",
  "bender-build-tools": "/bender-build-tools/static-1.3278",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3005",
  "stylex": "/stylex/static-1.34",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1098",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hs-resources": "/hs-resources/static-1.264",
  "pulse": "/pulse/static-1.686",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3864",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4205",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.98",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3758",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18659",
  "growth-data-modal": "/growth-data-modal/static-1.5568",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3156",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2180",
  "navigation-components": "/navigation-components/static-1.18240",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4978",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.830",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10312",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7693",
  "ui-universal-auth": "/ui-universal-auth/static-1.9082",
  "user-context": "/user-context/static-1.5199",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10177",
  "magpie-lib": "/magpie-lib/static-1.5610",
  "navigation-messaging": "/navigation-messaging/static-1.7567",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21721",
  "copilot-toolkit": "/copilot-toolkit/static-1.11360",
  "cms-field-types": "/cms-field-types/static-1.4902",
  "content-icons-ui": "/content-icons-ui/static-1.2251",
  "integrations-lib": "/integrations-lib/static-1.16445",
  "calling-global-api": "/calling-global-api/static-1.64820",
  "calling-internal-common": "/calling-internal-common/static-1.31398",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66202",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58496",
  "commerce-products-lib": "/commerce-products-lib/static-1.9868",
  "crm-links": "/crm-links/static-1.6396",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9506",
  "file-manager-components": "/file-manager-components/static-1.23844",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4288",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.723",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49053",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4033",
  "property-value-citations": "/property-value-citations/static-1.2503",
  "smart-property-lib": "/smart-property-lib/static-1.7628",
  "tiered-pricing": "/tiered-pricing/static-1.1413",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9152",
  "final-form": "/final-form/static-1.71",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19977",
  "tinymce-themes": "/tinymce-themes/static-1.56573",
  "data-token-picker": "/data-token-picker/static-1.16558",
  "hub-http-contrib": "/hub-http-contrib/static-1.3131",
  "interframe": "/interframe/static-3.4849",
  "tinymce-data": "/tinymce-data/static-1.40688",
  "tinymce-plugins": "/tinymce-plugins/static-1.57717",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5300",
  "onboarding-scopes": "/onboarding-scopes/static-1.6551",
  "ui-addon-opt": "/ui-addon-opt/static-4.8450",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4742",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.426",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.262",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1029",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "purchase-motions-api": "/purchase-motions-api/static-1.6057",
  "event-emitter": "/event-emitter/static-1.1038",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.189",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2112",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2208",
  "user-context-client": "/user-context-client/static-1.4678",
  "idb-keyval": "/idb-keyval/static-1.45",
  "magpie-types": "/magpie-types/static-1.5070",
  "nest": "/nest/static-1.321",
  "reactive-lib": "/reactive-lib/static-1.815",
  "simple-logging-lib": "/simple-logging-lib/static-1.3140",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.878",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17777",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1008",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13860",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5696",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7871",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10453",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.596",
  "calling-error-reporting": "/calling-error-reporting/static-1.31405",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11125",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6632",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1335",
  "customer-data-tracking": "/customer-data-tracking/static-1.6979",
  "commerce-permissions": "/commerce-permissions/static-1.866",
  "products-iframe-lib": "/products-iframe-lib/static-1.8168",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10561",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9519",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4244",
  "video-components-external": "/video-components-external/static-1.11566",
  "video-data-lib": "/video-data-lib/static-1.35224",
  "data-agent-kit": "/data-agent-kit/static-1.334",
  "feedback-loader": "/feedback-loader/static-1.29457",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10262",
  "fsm": "/fsm/static-1.3819",
  "policy-lib": "/policy-lib/static-1.6869",
  "react-colorpicker": "/react-colorpicker/static-2.10297",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10325",
  "FileManagerLib": "/FileManagerLib/static-1.39484",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9125",
  "FileManagerCore": "/FileManagerCore/static-1.39343",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7891",
  "layout-dnd-components": "/layout-dnd-components/static-1.12609",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11584",
  "react-codemirror": "/react-codemirror/static-1.10717",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9977",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15590",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15044",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7694",
  "breeze-engine-core": "/breeze-engine-core/static-1.286",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3107",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.256",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.500",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.638",
  "slack-ui-library": "/slack-ui-library/static-1.10482",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36112",
  "sales-views-client-types": "/sales-views-client-types/static-1.4348",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3657",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12601",
  "content-media-compositions": "/content-media-compositions/static-2.16608",
  "media-bridge-lib": "/media-bridge-lib/static-1.19075",
  "trellis-story-utils": "/trellis-story-utils/static-1.4602",
  "storybook-react": "/storybook-react/static-1.34",
  "audio-components": "/audio-components/static-1.6049",
  "FileManagerImages": "/FileManagerImages/static-1.36995",
  "video-components": "/video-components/static-1.13568",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "urlinator": "/urlinator/static-1.4626",
  "video-embed": "/video-embed/static-1.36058",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8793",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28809",
  "ContentData": "/ContentData/static-1.68685",
  "layout-data-lib": "/layout-data-lib/static-1.9909",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22298",
  "outpost": "/outpost/static-1.4260",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6669",
  "advanced-menus-core": "/advanced-menus-core/static-1.15269",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12186",
  "ExportDialog": "/ExportDialog/static-6.10472",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34284",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15268",
  "simple-menus-lib": "/simple-menus-lib/static-1.16785"
}
};
